import { render, staticRenderFns } from "./ad.vue?vue&type=template&id=37ba7780&scoped=true&"
import script from "./ad.vue?vue&type=script&lang=js&"
export * from "./ad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ba7780",
  null
  
)

export default component.exports